module.exports = __webpack_public_path__ + "static/media/the-force-awakens-thumb.208c0a61.png";